import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HmacSignatureService {
    private readonly secret = environment.security.hmacSecret;

    /**
     * Headers generated:
     * - X-Payload-Timestamp: unix timestamp
     * - X-Payload-Signature: HMAC-SHA256 signature in base64
     */
    generateSignature(query: string, variables: any, operationName: string): { timestamp: string; signature: string } {
        const timestamp = Math.floor(Date.now() / 1000);

        // Canonical string: query + '\n' + canonical JSON of variables + '\n' + operationName + '\n' + timestamp
        const canonical = `${query}\n${JSON.stringify(variables)}\n${operationName}\n${timestamp}`;

        // Compute HMAC-SHA256
        const key = CryptoJS.enc.Utf8.parse(this.secret);
        const hmac = CryptoJS.HmacSHA256(canonical, key);

        // Convert to Base64
        const signature = CryptoJS.enc.Base64.stringify(hmac);

        return {
            timestamp: String(timestamp),
            signature
        };
    }
}
